module.exports = __webpack_public_path__ + "img/06.98a607b6.jpg";